import { Link, router } from '@inertiajs/react';
import { Eyebrow } from '@/components/ui/Eyebrow';
import { ArrowBack, Trash } from '@/components/ui/icons';
import { formatDate } from '@/lib/formatDate';
import { trackUmamiEvent } from '@/lib/analytics';
import type { Message } from '@/types';

type ShowProps = {
  message: Message;
};

const onDelete = (id: number) => {
  if (window.confirm('Delete this message?')) {
    trackUmamiEvent('admin_message_delete', { source: 'show' });
    router.delete('/messages/' + id);
  }
};

export default function Show({ message }: ShowProps) {
  return (
    <div className="flex flex-col gap-6">
      <Link
        href="/messages"
        className="text-ink-soft hover:text-ink inline-flex w-fit items-center gap-1.5 text-sm"
      >
        <ArrowBack className="size-4" />
        <span>Back to inbox</span>
      </Link>

      <div className="border-line bg-surface rounded border p-6 sm:p-8">
        <div className="border-line-soft flex flex-wrap items-start justify-between gap-4 border-b pb-5">
          <div>
            <Eyebrow className="mb-2">Message</Eyebrow>
            <h1 className="font-display text-2xl font-semibold sm:text-3xl">{message.subject}</h1>
            <p className="text-ink-soft mt-2 text-sm">
              {message.name} &lt;{message.email}&gt;
            </p>
            <p className="text-ink-soft mt-1 text-xs tabular-nums">
              {formatDate(message.createdAt)}
            </p>
          </div>
          <button
            type="button"
            onClick={() => onDelete(message.id)}
            aria-label="Delete message"
            className="border-line text-error-fg hover:border-error-fg flex shrink-0 items-center gap-1.5 rounded-sm border px-3 py-2 text-sm transition-colors"
          >
            <Trash className="size-4" />
            <span>Delete</span>
          </button>
        </div>
        <p className="text-ink mt-6 max-w-[62ch] leading-relaxed whitespace-pre-wrap">
          {message.message}
        </p>
      </div>
    </div>
  );
}
